type Props = {
  color?: string
  width?: number
}

const IconSearch = ({ color = '#61667E', width = 24 }: Props) => {
  return (
    <svg
      className="cursor-pointer"
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.8103 5.43515C8.91733 2.4401 13.5412 2.55947 16.4169 5.43515C19.1668 8.18502 19.3349 12.539 16.9212 15.485L21.1899 19.7541L20.1292 20.8147L15.8601 16.5461C12.9141 18.9597 8.56017 18.7916 5.8103 16.0418C2.93462 13.1661 2.7994 8.33753 5.8103 5.43515ZM15.3562 6.49581C13.0131 4.15267 9.2141 4.15267 6.87096 6.49581C4.52781 8.83896 4.52781 12.6379 6.87096 14.9811C9.2141 17.3242 13.0131 17.3242 15.3562 14.9811C17.6994 12.6379 17.6994 8.83896 15.3562 6.49581Z"
        fill={color}
      />
    </svg>
  )
}

export default IconSearch
